import { TaskColor } from '@config/colors/task';
import { ScheduleState, ScheduleStyle } from './types';

export const activeStyles: ScheduleStyle = {
  regular: 'bg-white text-neutral-700 border-neutral-700',
  menu: 'text-neutral-700 border-neutral-700',
};

export const rejectedStyles = 'text-danger-600 border-danger-500 border-dashed bg-white';

export const styles: Record<TaskColor | 'default', Record<ScheduleState, ScheduleStyle>> = {
  default: {
    past: {
      regular: 'bg-neutral-200 text-neutral-700 border-neutral-200',
      menu: 'text-neutral-700 border-neutral-700',
    },
    accepted: {
      regular: 'bg-neutral-500 text-white border-neutral-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-neutral-600 border-neutral-400',
      menu: 'text-neutral-600 border-neutral-600',
    },
    approved: {
      regular: 'text-neutral-600 bg-neutral-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-neutral-600 border-neutral-400 border-dashed',
      menu: 'text-neutral-600 border-neutral-600',
    },
    draft: {
      regular: 'bg-white text-neutral-600 border-neutral-400 border-dashed',
      menu: 'text-neutral-600 border-neutral-600',
    },
  },
  amber: {
    past: {
      regular: 'bg-task-amber-200 text-task-amber-700 border-task-amber-200',
      menu: 'text-task-amber-700 border-task-amber-700',
    },
    accepted: {
      regular: 'bg-task-amber-500 text-white border-task-amber-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-amber-600 border-task-amber-400',
      menu: 'text-task-amber-600 border-task-amber-600',
    },
    approved: {
      regular: 'text-task-amber-600 bg-task-amber-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-amber-600 border-task-amber-400 border-dashed',
      menu: 'text-task-amber-600 border-task-amber-600',
    },
    draft: {
      regular: 'bg-white text-task-amber-600 border-task-amber-400 border-dashed',
      menu: 'text-task-amber-600 border-task-amber-600',
    },
  },
  aqua: {
    past: {
      regular: 'bg-task-aqua-200 text-task-aqua-700 border-task-aqua-200',
      menu: 'text-task-aqua-700 border-task-aqua-700',
    },
    accepted: {
      regular: 'bg-task-aqua-500 text-white border-task-aqua-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-aqua-600 border-task-aqua-400',
      menu: 'text-task-aqua-600 border-task-aqua-600',
    },
    approved: {
      regular: 'text-task-aqua-600 bg-task-aqua-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-aqua-600 border-task-aqua-400 border-dashed',
      menu: 'text-task-aqua-600 border-task-aqua-600',
    },
    draft: {
      regular: 'bg-white text-task-aqua-600 border-task-aqua-400 border-dashed',
      menu: 'text-task-aqua-600 border-task-aqua-600',
    },
  },
  blue: {
    past: {
      regular: 'bg-task-blue-200 text-task-blue-700 border-task-blue-200',
      menu: 'text-task-blue-700 border-task-blue-700',
    },
    accepted: {
      regular: 'bg-task-blue-500 text-white border-task-blue-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-blue-600 border-task-blue-400',
      menu: 'text-task-blue-600 border-task-blue-600',
    },
    approved: {
      regular: 'text-task-blue-600 bg-task-blue-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-blue-600 border-task-blue-400 border-dashed',
      menu: 'text-task-blue-600 border-task-blue-600',
    },
    draft: {
      regular: 'bg-white text-task-blue-600 border-task-blue-400 border-dashed',
      menu: 'text-task-blue-600 border-task-blue-600',
    },
  },
  ['blue-secondary']: {
    past: {
      regular:
        'bg-task-blue-secondary-200 text-task-blue-secondary-700 border-task-blue-secondary-200',
      menu: 'text-task-blue-secondary-700 border-task-blue-secondary-700',
    },
    accepted: {
      regular: 'bg-task-blue-secondary-500 text-white border-task-blue-secondary-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-blue-secondary-600 border-task-blue-secondary-400',
      menu: 'text-task-blue-secondary-600 border-task-blue-secondary-600',
    },
    approved: {
      regular: 'text-task-blue-secondary-600 bg-task-blue-secondary-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-blue-secondary-600 border-task-blue-secondary-400 border-dashed',
      menu: 'text-task-blue-secondary-600 border-task-blue-secondary-600',
    },
    draft: {
      regular: 'bg-white text-task-blue-secondary-600 border-task-blue-secondary-400 border-dashed',
      menu: 'text-task-blue-secondary-600 border-task-blue-secondary-600',
    },
  },
  brown: {
    past: {
      regular: 'bg-task-brown-200 text-task-brown-700 border-task-brown-200',
      menu: 'text-task-brown-700 border-task-brown-700',
    },
    accepted: {
      regular: 'bg-task-brown-500 text-white border-task-brown-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-brown-600 border-task-brown-400',
      menu: 'text-task-brown-600 border-task-brown-600',
    },
    approved: {
      regular: 'text-task-brown-600 bg-task-brown-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-brown-600 border-task-brown-400 border-dashed',
      menu: 'text-task-brown-600 border-task-brown-600',
    },
    draft: {
      regular: 'bg-white text-task-brown-600 border-task-brown-400 border-dashed',
      menu: 'text-task-brown-600 border-task-brown-600',
    },
  },
  cyan: {
    past: {
      regular: 'bg-task-cyan-200 text-task-cyan-700 border-task-cyan-200',
      menu: 'text-task-cyan-700 border-task-cyan-700',
    },
    accepted: {
      regular: 'bg-task-cyan-500 text-white border-task-cyan-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-cyan-600 border border-task-cyan-400',
      menu: 'text-task-cyan-600 border-task-cyan-600',
    },
    approved: {
      regular: 'text-task-cyan-600 bg-task-cyan-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-cyan-600 border border-task-cyan-400 border-dashed',
      menu: 'text-task-cyan-600 border-task-cyan-600',
    },
    draft: {
      regular: 'bg-white text-task-cyan-600 border border-task-cyan-400 border-dashed',
      menu: 'text-task-cyan-600 border-task-cyan-600',
    },
  },
  green: {
    past: {
      regular: 'bg-task-green-200 text-task-green-700 border-task-green-200',
      menu: 'text-task-green-700 border-task-green-700',
    },
    accepted: {
      regular: 'bg-task-green-500 text-white border-task-green-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-green-600 border-task-green-400',
      menu: 'text-task-green-600 border-task-green-600',
    },
    approved: {
      regular: 'text-task-green-600 bg-task-green-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-green-600 border-task-green-400 border-dashed',
      menu: 'text-task-green-600 border-task-green-600',
    },
    draft: {
      regular: 'bg-white text-task-green-600 border-task-green-400 border-dashed',
      menu: 'text-task-green-600 border-task-green-600',
    },
  },
  indigo: {
    past: {
      regular: 'bg-task-indigo-200 text-task-indigo-700 border-task-indigo-200',
      menu: 'text-task-indigo-700 border-task-indigo-700',
    },
    accepted: {
      regular: 'bg-task-indigo-500 text-white border-task-indigo-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-indigo-600 border-task-indigo-400',
      menu: 'text-task-indigo-600 border-task-indigo-600',
    },
    approved: {
      regular: 'text-task-indigo-600 bg-task-indigo-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-indigo-600 border-task-indigo-400 border-dashed',
      menu: 'text-task-indigo-600 border-task-indigo-600',
    },
    draft: {
      regular: 'bg-white text-task-indigo-600 border-task-indigo-400 border-dashed',
      menu: 'text-task-indigo-600 border-task-indigo-600',
    },
  },
  lime: {
    past: {
      regular: 'bg-task-lime-200 text-task-lime-700 border-task-lime-200',
      menu: 'text-task-lime-700 border-task-lime-700',
    },
    accepted: {
      regular: 'bg-task-lime-500 text-white border-task-lime-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-lime-600 border-task-lime-400',
      menu: 'text-task-lime-600 border-task-lime-600',
    },
    approved: {
      regular: 'text-task-lime-600 bg-task-lime-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-lime-600 border-task-lime-400 border-dashed',
      menu: 'text-task-lime-600 border-task-lime-600',
    },
    draft: {
      regular: 'bg-white text-task-lime-600 border-task-lime-400 border-dashed',
      menu: 'text-task-lime-600 border-task-lime-600',
    },
  },
  orange: {
    past: {
      regular: 'bg-task-orange-200 text-task-orange-700 border-task-orange-200',
      menu: 'text-task-orange-700 border-task-orange-700',
    },
    accepted: {
      regular: 'bg-task-orange-500 text-white border-task-orange-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-orange-600 border-task-orange-400',
      menu: 'text-task-orange-600 border-task-orange-600',
    },
    approved: {
      regular: 'text-task-orange-600 bg-task-orange-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-orange-600 border-task-orange-400 border-dashed',
      menu: 'text-task-orange-600 border-task-orange-600',
    },
    draft: {
      regular: 'bg-white text-task-orange-600 border-task-orange-400 border-dashed',
      menu: 'text-task-orange-600 border-task-orange-600',
    },
  },
  ['orange-secondary']: {
    past: {
      regular:
        'bg-task-orange-secondary-200 text-task-orange-secondary-700 border-task-orange-secondary-200',
      menu: 'text-task-orange-secondary-700 border-task-orange-secondary-700',
    },
    accepted: {
      regular: 'bg-task-orange-secondary-500 text-white border-task-orange-secondary-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-orange-secondary-600 border-task-orange-secondary-400',
      menu: 'text-task-orange-secondary-600 border-task-orange-secondary-600',
    },
    approved: {
      regular: 'text-task-orange-secondary-600 bg-task-orange-secondary-50',
      menu: '',
    },
    withoutTeam: {
      regular:
        'bg-white text-task-orange-secondary-600 border-task-orange-secondary-400 border-dashed',
      menu: 'text-task-orange-secondary-600 border-task-orange-secondary-600',
    },
    draft: {
      regular:
        'bg-white text-task-orange-secondary-600 border-task-orange-secondary-400 border-dashed',
      menu: 'text-task-orange-secondary-600 border-task-orange-secondary-600',
    },
  },
  pink: {
    past: {
      regular: 'bg-task-pink-200 text-task-pink-700 border-task-pink-200',
      menu: 'text-task-pink-700 border-task-pink-700',
    },
    accepted: {
      regular: 'bg-task-pink-500 text-white border-task-pink-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-pink-600 border-task-pink-400',
      menu: 'text-task-pink-600 border-task-pink-600',
    },
    approved: {
      regular: 'text-task-pink-600 bg-task-pink-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-pink-600 border-task-pink-400 border-dashed',
      menu: 'text-task-pink-600 border-task-pink-600',
    },
    draft: {
      regular: 'bg-white text-task-pink-600 border-task-pink-400 border-dashed',
      menu: 'text-task-pink-600 border-task-pink-600',
    },
  },
  ['pink-secondary']: {
    past: {
      regular:
        'bg-task-pink-secondary-200 text-task-pink-secondary-700 border-task-pink-secondary-200',
      menu: 'text-task-pink-secondary-700 border-task-pink-secondary-700',
    },
    accepted: {
      regular: 'bg-task-pink-secondary-500 text-white border-task-pink-secondary-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-pink-secondary-600 border-task-pink-secondary-400',
      menu: 'text-task-pink-secondary-600 border-task-pink-secondary-600',
    },
    approved: {
      regular: 'text-task-pink-secondary-600 bg-task-pink-secondary-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-pink-secondary-600 border-task-pink-secondary-400 border-dashed',
      menu: 'text-task-pink-secondary-600 border-task-pink-secondary-600',
    },
    draft: {
      regular: 'bg-white text-task-pink-secondary-600 border-task-pink-secondary-400 border-dashed',
      menu: 'text-task-pink-secondary-600 border-task-pink-secondary-600',
    },
  },
  purple: {
    past: {
      regular: 'bg-task-purple-200 text-task-purple-700 border-task-purple-200',
      menu: 'text-task-purple-700 border-task-purple-700',
    },
    accepted: {
      regular: 'bg-task-purple-500 text-white border-task-purple-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-purple-600 border-task-purple-400',
      menu: 'text-task-purple-600 border-task-purple-600',
    },
    approved: {
      regular: 'text-task-purple bg-task-purple-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-purple-600 border-task-purple-400 border-dashed',
      menu: 'text-task-purple-600 border-task-purple-600',
    },
    draft: {
      regular: 'bg-white text-task-purple-600 border-task-purple-400 border-dashed',
      menu: 'text-task-purple-600 border-task-purple-600',
    },
  },
  ['purple-secondary']: {
    past: {
      regular:
        'bg-task-purple-secondary-200 text-task-purple-secondary-700 border-task-purple-secondary-200',
      menu: 'text-task-purple-secondary-700 border-task-purple-secondary-700',
    },
    accepted: {
      regular: 'bg-task-purple-secondary-500 text-white border-task-purple-secondary-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-purple-secondary-600 border-task-purple-secondary-400',
      menu: 'text-task-purple-secondary-600 border-task-purple-secondary-600',
    },
    approved: {
      regular: 'text-task-purple-secondary-600 bg-task-purple-secondary-50',
      menu: '',
    },
    withoutTeam: {
      regular:
        'bg-white text-task-purple-secondary-600 border-task-purple-secondary-400 border-dashed',
      menu: 'text-task-purple-secondary-600 border-task-purple-secondary-600',
    },
    draft: {
      regular:
        'bg-white text-task-purple-secondary-600 border-task-purple-secondary-400 border-dashed',
      menu: 'text-task-purple-secondary-600 border-task-purple-secondary-600',
    },
  },
  steel: {
    past: {
      regular: 'bg-task-steel-200 text-task-steel-700 border-task-steel-200',
      menu: 'text-task-steel-700 border-task-steel-700',
    },
    accepted: {
      regular: 'bg-task-steel-500 text-white border-task-steel-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-steel-600 border-task-steel-400',
      menu: 'text-task-steel-600 border-task-steel-600',
    },
    approved: {
      regular: 'text-task-steel-600 bg-task-steel-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-steel-600 border-task-steel-400 border-dashed',
      menu: 'text-task-steel-600 border-task-steel-600',
    },
    draft: {
      regular: 'bg-white text-task-steel-600 border-task-steel-400 border-dashed',
      menu: 'text-task-steel-600 border-task-steel-600',
    },
  },
  stone: {
    past: {
      regular: 'bg-task-stone-200 text-task-stone-700 border-task-stone-200',
      menu: 'text-task-stone-700 border-task-stone-700',
    },
    accepted: {
      regular: 'bg-task-stone-500 text-white border-task-stone-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-stone-600 border-task-stone-400',
      menu: 'text-task-stone-600 border-task-stone-600',
    },
    approved: {
      regular: 'text-task-stone-600 bg-task-stone-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-stone-600 border-task-stone-400 border-dashed',
      menu: 'text-task-stone-600 border-task-stone-600',
    },
    draft: {
      regular: 'bg-white text-task-stone-600 border-task-stone-400 border-dashed',
      menu: 'text-task-stone-600 border-task-stone-600',
    },
  },
  yellow: {
    past: {
      regular: 'bg-task-yellow-200 text-task-yellow-700 border-task-yellow-200',
      menu: 'text-task-yellow-700 border-task-yellow-700',
    },
    accepted: {
      regular: 'bg-task-yellow-500 text-white border-task-yellow-500',
      menu: 'text-white border-white',
    },
    notAccepted: {
      regular: 'bg-white text-task-yellow-600 border-task-yellow-400',
      menu: 'text-task-yellow-600 border-task-yellow-600',
    },
    approved: {
      regular: 'text-task-yellow-600 bg-task-yellow-50',
      menu: '',
    },
    withoutTeam: {
      regular: 'bg-white text-task-yellow-600 border-task-yellow-400 border-dashed',
      menu: 'text-task-yellow-600 border-task-yellow-600',
    },
    draft: {
      regular: 'bg-white text-task-yellow-600 border-task-yellow-400 border-dashed',
      menu: 'text-task-yellow-600 border-task-yellow-600',
    },
  },
};
